import { render, staticRenderFns } from "./Considerations.vue?vue&type=template&id=6e130d2e"
import script from "./Considerations.vue?vue&type=script&lang=js"
export * from "./Considerations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports